export default "__VITE_ASSET__DF2UrOmA__"